/*
 * lv-filter-steps.js · de filterlade in twee stappen (FL2).
 * Jens, 30 okt 2026: "nee ik wil juist niet dat ie zo uitgeklapt is en ik wil dat per variablewe waar je op klikt dat je
 * dus naar en nieuw zijvenster gaat. Ik wil FL2 die van 2 stappen".
 *
 * Werking
 * - Eerste scherm: alleen rijen. Bovenaan "Sort by" met de huidige keuze grijs rechts, daaronder elke filtergroep met de
 *   klaargezette waarden grijs rechts. Niets klapt uit.
 * - Een klik op een rij schuift een tweede scherm van rechts in (200 ms): bovenin een terugpijl met de groepsnaam,
 *   daaronder de waarden met vinkje (zoekveld bij meer dan tien waarden, zoals in de chipvakken), voor Price de velden
 *   Minimum en Maximum, voor Sort by de opties met vinkje. Ook op mobiel; de keuzelijst van de telefoon (SL1) vervalt.
 * - Alles schrijft door naar de invoervelden en de select sort_by van het formulier in de lade. Die blijven de enige
 *   bron. Sinds 31 okt 2026 voert assets/lv-filter-stage.js elke keuze direct door (Jens: "als je een waarde aanklikt
 *   dat ie gelijk wordt doorgevoerd"); de lade blijft open en blijft op hetzelfde scherm. Na elke bijwerking
 *   (event lv:filter-live) werkt refresh() de vinkjes, de uitgeschakelde waarden, de kop en de voet bij; het scherm
 *   zelf (.lv-steps) wordt door de morph van het thema overgeslagen. "Show N items" sluit alleen nog.
 * - Onderbalk: op het eerste scherm "Clear all", op het tweede "Clear" voor alleen die groep (lvFilterStage.onClear).
 * - De rijen en schermen worden gebouwd in .lv-steps (blocks/filters.liquid). Is dat leeg (geen script, of net
 *   bijgewerkt door het thema), dan staat de oude lijst met groepen er nog; CSS verbergt die zodra .lv-steps gevuld is.
 * Teksten: data-attributen op .lv-steps en de terugknop, uit locales (hv.filters.*, actions.*).
 */
(function () {
  'use strict';
  if (window.lvFilterSteps) return;

  var DRAWER = '#filters-drawer';
  var CHEV_R = '<svg class="lv-row__chev" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M4.3 2.5 7.8 6l-3.5 3.5"/></svg>';
  var CHECK = '<svg class="lv-opt__ck" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M2.5 7.4 5.6 10.4 11.5 3.6"/></svg>';
  var SEARCH = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="7" cy="7" r="5"/><path d="M11 11l3.5 3.5"/></svg>';
  var REDUCE = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  var state = { k: null, q: '', opts: [] };

  function root() { return document.querySelector(DRAWER); }
  function box() { var r = root(); return r ? r.querySelector('.lv-steps') : null; }
  function dialog() { var r = root(); return r ? r.querySelector('dialog') : null; }
  function groups() { var r = root(); return r ? r.querySelectorAll('.facets__filters-wrapper details.facets__panel') : []; }
  function sortSelect() { var r = root(); return r ? r.querySelector('.sorting-filter--panel select[name="sort_by"]') : null; }
  function T(name, d) { var b = box(); return (b && b.getAttribute('data-' + name)) || d; }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function labelOf(g) { var l = g.querySelector('.facets__label'); return l ? l.textContent.replace(/\s+/g, ' ').trim() : ''; }

  /* ------------------------------------------------------------ waarden */
  function optionsOf(group) {
    var out = [];
    group.querySelectorAll('facet-inputs-component input[type="checkbox"]').forEach(function (inp) {
      var lab = inp.getAttribute('data-label') || inp.getAttribute('aria-label');
      if (!lab && inp.id) { var l = group.querySelector('label[for="' + inp.id + '"]'); if (l) lab = l.textContent; }
      out.push({ el: inp, label: (lab || inp.value || '').replace(/\s+/g, ' ').trim(), on: function () { return this.el.checked; }, off: inp.disabled && !inp.checked });
    });
    group.querySelectorAll('.custom-style-option').forEach(function (b) {
      out.push({ el: b, label: (b.getAttribute('data-style-label') || b.textContent).trim(), on: function () { return this.el.getAttribute('aria-pressed') === 'true'; }, off: false });
    });
    return out;
  }
  function priceText(group) {
    var st = group.querySelector('facet-status-component [ref="facetStatus"]');
    return st ? st.textContent.replace(/\s+/g, '').trim() : '';
  }
  function valueOf(group) {
    if (group.querySelector('price-facet-component')) return priceText(group);
    return optionsOf(group).filter(function (o) { return o.on(); }).map(function (o) { return o.label; }).join(', ');
  }
  function sortValue() {
    var s = sortSelect();
    if (!s || s.selectedIndex < 0) return '';
    return s.options[s.selectedIndex].textContent.trim();
  }

  /* ------------------------------------------------------------ scherm 1 */
  function rowHtml(k, label, value) {
    return '<li><button type="button" class="lv-row" data-lv-row="' + k + '"><span class="lv-row__l">' + esc(label) + '</span>' +
      '<span class="lv-row__v">' + esc(value) + '</span>' + CHEV_R + '</button></li>';
  }
  function build() {
    var b = box(); if (!b) return;
    var html = '<div class="lv-steps__vp"><div class="lv-step lv-step--1"><ul class="lv-rows" role="list">';
    if (sortSelect()) html += rowHtml('sort', T('sort-label', 'Sort by'), sortValue());
    groups().forEach(function (g, i) { html += rowHtml(String(i), labelOf(g), valueOf(g)); });
    html += '</ul></div><div class="lv-step lv-step--2" hidden></div></div>';
    b.innerHTML = html;
    state.k = null; state.q = '';
    header(null);
    footer(false);
  }
  function paintRows() {
    var b = box(); if (!b) return;
    b.querySelectorAll('.lv-row').forEach(function (r) {
      var k = r.getAttribute('data-lv-row'), v = '';
      if (k === 'sort') v = sortValue();
      else { var g = groups()[+k]; if (g) v = valueOf(g); }
      var span = r.querySelector('.lv-row__v');
      if (span && span.textContent !== v) span.textContent = v;
    });
  }

  /* ------------------------------------------------------------ kop en voet */
  function header(title) {
    var r = root(); if (!r) return;
    var back = r.querySelector('.lv-step-back'), h = r.querySelector('.facets-drawer__title');
    if (!back || !h) return;
    if (title === null) { back.hidden = true; h.hidden = false; return; }
    back.querySelector('.lv-step-back__t').textContent = title;
    back.hidden = false; h.hidden = true;
  }
  function footer(one) {
    var r = root(); if (!r) return;
    var c = r.querySelector('[data-lv-apply="clear"]'); if (!c) return;
    var t = one ? c.getAttribute('data-lv-one') : c.getAttribute('data-lv-all');
    if (t && c.textContent.trim() !== t) c.textContent = t;
  }

  /* ------------------------------------------------------------ scherm 2 */
  function stepHtml(k) {
    var html = '';
    if (k === 'sort') {
      var s = sortSelect();
      html += '<ul class="lv-opts" role="radiogroup" aria-label="' + esc(T('sort-label', 'Sort by')) + '">';
      Array.prototype.forEach.call(s.options, function (o, i) {
        var on = i === s.selectedIndex;
        html += '<li><button type="button" class="lv-opt" role="radio" data-lv-sort="' + esc(o.value) + '" aria-checked="' + on + '" tabindex="' + (on ? 0 : -1) + '"><span>' + esc(o.textContent.trim()) + '</span>' + CHECK + '</button></li>';
      });
      return html + '</ul>';
    }
    var g = groups()[+k];
    var pf = g.querySelector('price-facet-component');
    if (pf) {
      var mi = pf.querySelector('[ref="minInput"]'), ma = pf.querySelector('[ref="maxInput"]');
      var curEl = pf.querySelector('.price-facet__label'), cur = curEl ? curEl.textContent.trim() : '';
      var hintEl = pf.querySelector('.price-facet__highest-price'), hint = hintEl ? hintEl.textContent.replace(/\s+/g, ' ').trim() : '';
      var field = function (inp, key, lab) {
        if (!inp) return '';
        return '<label class="lv-pf"><span class="lv-pf__l">' + esc(lab) + '</span><span class="lv-pf__box">' + (cur ? '<span class="lv-pf__cur" aria-hidden="true">' + esc(cur) + '</span>' : '') +
          '<input type="text" inputmode="decimal" autocomplete="off" data-lv-price="' + key + '" value="' + esc(inp.value || '') + '" placeholder="' + esc(inp.getAttribute('placeholder') || '') + '"></span></label>';
      };
      return '<div class="lv-price">' + field(mi, 'min', T('min', 'Minimum')) + field(ma, 'max', T('max', 'Maximum')) + '</div>' + (hint ? '<p class="lv-price__hint">' + esc(hint) + '</p>' : '');
    }
    state.opts = optionsOf(g);
    if (state.opts.length > 10) {
      var ph = T('search', 'Search %NAME%').replace('%NAME%', labelOf(g).toLowerCase());
      html += '<label class="lv-search">' + SEARCH + '<input type="text" enterkeyhint="search" autocomplete="off" placeholder="' + esc(ph) + '" aria-label="' + esc(ph) + '" value="' + esc(state.q) + '"></label>';
    }
    html += '<ul class="lv-opts" role="list">' + listHtml() + '</ul>';
    return html;
  }
  function linkInputs() {
    var b = box(); if (!b) return;
    b.querySelectorAll('.lv-step--2 .lv-opt[data-i]').forEach(function (x) {
      var o = state.opts[+x.getAttribute('data-i')];
      x.__lvInput = o ? o.el : null;
    });
  }
  function listHtml() {
    var q = state.q.toLowerCase(), html = '', shown = 0;
    state.opts.forEach(function (o, i) {
      if (q && o.label.toLowerCase().indexOf(q) === -1) return;
      shown++;
      html += '<li><button type="button" class="lv-opt" data-i="' + i + '" aria-pressed="' + o.on() + '"' + (o.off ? ' disabled' : '') + '><span>' + esc(o.label) + '</span>' + CHECK + '</button></li>';
    });
    if (!shown) html += '<li class="lv-opts__empty">' + esc(T('no-match', 'No match')) + '</li>';
    return html;
  }
  function paintOpts() {
    var b = box(); if (!b || state.k === null) return;
    var s2 = b.querySelector('.lv-step--2');
    if (state.k === 'sort') {
      var s = sortSelect();
      s2.querySelectorAll('[data-lv-sort]').forEach(function (x) {
        var on = s && x.getAttribute('data-lv-sort') === s.value;
        x.setAttribute('aria-checked', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
      });
      return;
    }
    s2.querySelectorAll('.lv-opt[data-i]').forEach(function (x) {
      var o = state.opts[+x.getAttribute('data-i')];
      if (o) x.setAttribute('aria-pressed', o.on() ? 'true' : 'false');
    });
  }

  function slide(el, from, to, done) {
    if (REDUCE.matches || typeof el.animate !== 'function') { done(); return; }
    var a = el.animate([{ transform: from }, { transform: to }], { duration: 200, easing: 'cubic-bezier(.2,.7,.3,1)' });
    a.onfinish = done; a.oncancel = done;
  }

  function open(k) {
    var b = box(); if (!b) return;
    var s1 = b.querySelector('.lv-step--1'), s2 = b.querySelector('.lv-step--2'), vp = b.querySelector('.lv-steps__vp');
    var title = k === 'sort' ? T('sort-label', 'Sort by') : labelOf(groups()[+k]);
    state.k = k; state.q = '';
    s2.innerHTML = stepHtml(k);
    linkInputs();
    s2.hidden = false;
    header(title);
    footer(true);
    var d = dialog(); if (d) d.scrollTop = 0;
    // Tijdens het schuiven ligt scherm 2 over scherm 1, de hoogte staat vast: de lade verspringt niet
    vp.style.minHeight = Math.max(s1.offsetHeight, s2.offsetHeight) + 'px';
    s2.classList.add('is-moving');
    slide(s2, 'translateX(100%)', 'translateX(0)', function () {
      s2.classList.remove('is-moving');
      s1.hidden = true;
      vp.style.minHeight = '';
    });
    var back = root().querySelector('.lv-step-back');
    if (back) back.focus({ preventScroll: true });
  }
  function back() {
    var b = box(); if (!b || state.k === null) return;
    var s1 = b.querySelector('.lv-step--1'), s2 = b.querySelector('.lv-step--2'), vp = b.querySelector('.lv-steps__vp');
    var k = state.k;
    state.k = null;
    paintRows();
    s1.hidden = false;
    header(null);
    footer(false);
    var d = dialog(); if (d) d.scrollTop = 0;
    vp.style.minHeight = Math.max(s1.offsetHeight, s2.offsetHeight) + 'px';
    s2.classList.add('is-moving');
    slide(s2, 'translateX(0)', 'translateX(100%)', function () {
      s2.classList.remove('is-moving');
      s2.hidden = true; s2.innerHTML = '';
      vp.style.minHeight = '';
    });
    var row = b.querySelector('.lv-row[data-lv-row="' + k + '"]');
    if (row) row.focus({ preventScroll: true });
  }

  /* ------------------------------------------------------------ acties */
  function pickSort(v) {
    var s = sortSelect(); if (!s) return;
    if (s.value !== v) { s.value = v; s.dispatchEvent(new Event('change', { bubbles: true })); }
    paintOpts();
  }
  function setPrice(f) {
    var g = groups()[+state.k]; if (!g) return;
    var target = g.querySelector(f.getAttribute('data-lv-price') === 'min' ? '[ref="minInput"]' : '[ref="maxInput"]');
    var v = f.value.replace(/[^0-9.,' ]/g, '');
    if (v !== f.value) f.value = v;
    if (!target) return;
    target.value = v;
    target.dispatchEvent(new Event('input', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.closest(DRAWER)) return;
    var row = t.closest('.lv-row');
    if (row) { e.preventDefault(); open(row.getAttribute('data-lv-row')); return; }
    if (t.closest('.lv-step-back')) { e.preventDefault(); back(); return; }
    var srt = t.closest('[data-lv-sort]');
    if (srt) { e.preventDefault(); pickSort(srt.getAttribute('data-lv-sort')); return; }
    var opt = t.closest('.lv-opt[data-i]');
    if (opt && !opt.disabled) {
      e.preventDefault();
      var o = state.opts[+opt.getAttribute('data-i')];
      if (o) o.el.click();
      paintOpts();
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.closest(DRAWER + ' .lv-steps')) return;
    if (t.hasAttribute('data-lv-price')) { setPrice(t); return; }
    if (t.closest('.lv-search')) {
      state.q = t.value;
      var ul = box().querySelector('.lv-step--2 .lv-opts');
      if (ul) { ul.innerHTML = listHtml(); linkInputs(); }
    }
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.closest(DRAWER + ' .lv-steps')) return;
    if (t.hasAttribute('data-lv-price') && e.key === 'Enter') {
      // Prijs direct doorvoeren; de lade blijft open (31 okt 2026)
      e.preventDefault();
      if (window.lvFilterStage) window.lvFilterStage.apply();
      return;
    }
    var srt = t.closest('[data-lv-sort]');
    if (srt && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      e.preventDefault();
      var all = Array.prototype.slice.call(srt.closest('.lv-opts').querySelectorAll('[data-lv-sort]'));
      var n = all[all.indexOf(srt) + (e.key === 'ArrowDown' ? 1 : -1)];
      if (n) { n.focus(); pickSort(n.getAttribute('data-lv-sort')); }
    }
  });

  // Gekozen (filter of sortering): waarden op scherm 1 en vinkjes op scherm 2 bijwerken
  document.addEventListener('lv:filter-stage', function () { paintRows(); paintOpts(); });

  // Na het doorvoeren (assets/lv-filter-stage.js): de lade is bijgewerkt door de morph van het thema, maar .lv-steps
  // niet. Kop en voet horen bij het scherm waar de bezoeker staat; waarden kunnen nu uitgeschakeld zijn (geen items).
  function refresh() {
    var b = box(); if (!b) return;
    if (!b.firstChild) { build(); return; }
    if (state.k === null) { header(null); footer(false); paintRows(); return; }
    var g = state.k === 'sort' ? null : groups()[+state.k];
    if (state.k !== 'sort' && !g) { build(); return; }
    header(state.k === 'sort' ? T('sort-label', 'Sort by') : labelOf(g));
    footer(true);
    paintRows();
    if (state.k === 'sort' || g.querySelector('price-facet-component')) { paintOpts(); return; }
    var next = optionsOf(g);
    var same = next.length === state.opts.length && next.every(function (o, i) { return o.label === state.opts[i].label; });
    state.opts = next;
    var s2 = b.querySelector('.lv-step--2');
    if (!same) {
      var ul = s2.querySelector('.lv-opts');
      if (ul) ul.innerHTML = listHtml();
    } else {
      s2.querySelectorAll('.lv-opt[data-i]').forEach(function (x) {
        var o = state.opts[+x.getAttribute('data-i')];
        if (!o) return;
        x.setAttribute('aria-pressed', o.on() ? 'true' : 'false');
        if (x.disabled !== !!o.off) x.disabled = !!o.off;
      });
    }
    linkInputs();
  }
  document.addEventListener('lv:filter-live', refresh);

  function hookClear() {
    if (!window.lvFilterStage) return;
    window.lvFilterStage.onClear = function () {
      if (state.k === null) return false;
      if (state.k === 'sort') {
        var det = root().querySelector('.sorting-filter--panel details[data-default-sort-by]');
        var def = det ? det.getAttribute('data-default-sort-by') : null;
        var s = sortSelect();
        if (s && def != null) pickSort(def);
        else if (s) pickSort(s.options[0].value);
        return true;
      }
      var g = groups()[+state.k];
      if (!g) return false;
      window.lvFilterStage.clear(g);
      var s2 = box().querySelector('.lv-step--2');
      state.opts = []; s2.innerHTML = stepHtml(state.k); linkInputs();
      return true;
    };
  }

  /* ------------------------------------------------------------ openen en sluiten */
  var watched = null;
  var mo = new MutationObserver(function () {
    var d = dialog();
    if (d && d.open) { if (!d.__lvOpen) { d.__lvOpen = true; build(); } }
    else if (d) d.__lvOpen = false;
  });
  function watch() {
    var d = dialog();
    if (!d || d === watched) return;
    mo.disconnect();
    mo.observe(d, { attributes: true, attributeFilter: ['open'] });
    watched = d;
  }
  function init() {
    hookClear();
    watch();
    var b = box();
    if (b && !b.firstChild) build();
  }
  // Sluiten: volgende keer weer op het eerste scherm
  document.addEventListener('close', function (e) {
    if (e.target instanceof HTMLDialogElement && e.target.closest(DRAWER)) { e.target.__lvOpen = false; setTimeout(build, 0); }
  }, true);
  document.addEventListener('filter:update', function () { setTimeout(init, 400); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.lvFilterSteps = { build: build, open: open, back: back, refresh: refresh };
})();
